// extracted by css-extract-rspack-plugin
export default {"taskContainer":"TasksList_taskContainer__l4jkY","deadline":"TasksList_deadline__dONeV","taskWrapper":"TasksList_taskWrapper__crvwp"};